/**
 * This is the fragment shader for the "mask" program.
 * 
 * It just colors the pixels in the mask black, and then we use the WebGL
 * stencil buffer to mask the output of the "raster" program.
 */

precision highp float; // Use high precision for floats

void main() {
  gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0); // Color = black
}
